import {captureException} from "@sentry/vue";
import {type TreeItem} from "../types/navigation-items";

// This isn't meant to be very generic. Doesn't need to be reactive since we should always await for nav before rendering. We also don't expect to encounter errors in the HTTP request so we swallow them.
// Also note that the CSRF handling doesn't do anything, we needed to disable CSRF for this route fully to get this to work at all for some reason.
export async function useNavigationData(): Promise<TreeItem[]> {
	const {csrf} = useCsrf();

	try {
		return await $fetch("/api/navigation", {
			headers: {
				...(csrf
					? {
							"csrf-token": csrf,
						}
					: {}),
			},
		});
	} catch (error) {
		captureException(error);
		// eslint-disable-next-line no-console
		console.error(error);

		return [];
	}
}
